import { setSportId } from "../../helpers";
/**
 * Group markets received against cardConfiguration
 * @param markets
 * @param cardConfig
 */
export var groupMarketsBySport = function (markets, cardConfig) {
    var marketsBySport = {};
    var sportIds = Object.keys(cardConfig);
    var currentSportId;
    sportIds.forEach(function (x) { return marketsBySport[x] = []; });
    markets.forEach(function (m) {
        currentSportId = setSportId(sportIds, m);
        marketsBySport[currentSportId].push(m);
    });
    // Object.keys(cardConfig).map(sportId => {
    //     let availableMarkets = markets.filter(m => {
    //         currentSportId = setSportId(sportIds, m);
    //         return currentSportId === sportId.toString()
    //     });
    //     marketsBySport[sportId] = availableMarkets;
    // });
    return marketsBySport;
};
//# sourceMappingURL=groupMarketsBySport.js.map